import { createTelemetry, createTelemetryObject } from '@shared/core';

const category = 'SocialAccount';

export const socialAccountTelemetry = createTelemetryObject({
  actions: {
    socialIntercept: (eventType, socialProvider) => ({
      action: 'CreateAccountWithEmailPassword',
      actionType: 'click',
      label: 'Create account with email and password',
      category,
      pagePrefix: 'marketing',
      page: 'social_intercept',
      extraInfo: { accountType: socialProvider, eventType }
    })
  },
  pages: {}
});

const { TelemetryProvider, useTelemetry: useSocialAccountTelemetry } = createTelemetry(socialAccountTelemetry);

export { TelemetryProvider, useSocialAccountTelemetry };
